export default function getCartItemElemById(id, container) {
  return container.querySelector(`[data-cart-item][data-id="${id}"]`)
}
